import { StepStatus } from 'src/graphql/types/steps'

import { isStepColumn, parseStepColumnKey } from './stepColumns'

type StepFilterClause = {
  type?: string
  customStepId?: string
  status?: string
}

/**
 * Builds the `$stepFilters` variable for the applicants table query.
 *
 * Always includes the two active-status clauses that power the To Do column.
 * Each enabled step column adds a type clause so the column's cell can show
 * that step's status regardless of status — query weight scales with the
 * number of step columns turned on. With no step columns enabled, the output
 * is identical to the previous hardcoded filter.
 */
export const buildStepFiltersVariable = (
  enabledStepColumnKeys: string[] = []
): { OR: StepFilterClause[] } => {
  const clauses: StepFilterClause[] = [
    { status: StepStatus.IN_PROGRESS },
    { status: StepStatus.PENDING_REVIEW },
  ]

  const seen = new Set<string>()
  enabledStepColumnKeys.filter(isStepColumn).forEach((key) => {
    const { type, customStepId } = parseStepColumnKey(key)
    const clause: StepFilterClause = customStepId
      ? { type, customStepId }
      : { type }
    const dedupeKey = customStepId ?? type
    if (!seen.has(dedupeKey)) {
      seen.add(dedupeKey)
      clauses.push(clause)
    }
  })

  return { OR: clauses }
}
